export default "__VITE_ASSET__D0s2t2qs__"